// ----------------------------------------------------------------------------
// Component: iam-account-menu
// ----------------------------------------------------------------------------
// Lightweight account dropdown in the header. The panel opens on hover (CSS,
// desktop) and on keyboard focus (this component), mirroring the cart dropdown.
// Unlike the cart it has no dynamic content — just static links, including a
// "Subscriptions" link straight to the Recharge customer portal.

// Styles
import './_account-menu.scss';
var WRAPPER_SELECTOR = '.account-icon--dropdown';
var TRIGGER_SELECTOR = '.account-dropdown__header-link';
var OPEN_CLASS = '--open';
class iamAccountMenu extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.closest(WRAPPER_SELECTOR);
    this.trigger = this.querySelector(TRIGGER_SELECTOR);
    this.addEventListener('focusin', this.open.bind(this));
    this.addEventListener('focusout', this.close.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
  }
  open() {
    var _this$wrapper;
    (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || _this$wrapper.classList.add(OPEN_CLASS);
  }
  close() {
    var _this$wrapper2;
    (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || _this$wrapper2.classList.remove(OPEN_CLASS);
  }
  onKeyup(event) {
    var _this$wrapper3;
    if (event.key === 'Escape' && (_this$wrapper3 = this.wrapper) !== null && _this$wrapper3 !== void 0 && _this$wrapper3.classList.contains(OPEN_CLASS)) {
      var _this$trigger;
      (_this$trigger = this.trigger) === null || _this$trigger === void 0 || _this$trigger.focus();
      this.close();
    }
  }
}
if (!customElements.get('iam-account-menu')) {
  customElements.define('iam-account-menu', iamAccountMenu);
}